module.exports = __webpack_public_path__ + "static/media/ava.bd178cdc.png";